import React from "react";

const Kotlin_Output = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Output</h1>
      <p>Content for Kotlin Output goes here.</p>
    </div>
  );
};

export default Kotlin_Output;
